import { useState } from "react";
import {
  Group,
  Box,
  Collapse,
  ThemeIcon,
  UnstyledButton,
} from "@mantine/core";
import { IconChevronRight } from "@tabler/icons-react";
import { Link, useLocation } from "react-router-dom";
import AppUseIcon from "./AppUseIcon";
import classes from "./NavbarLinksGroup.module.css";

interface LinksGroupProps {
  icon?: string;
  label: string;
  initiallyOpened?: boolean;
  link?: string;
  links?: { label: string; link: string }[];
  onOpenmenu?: () => any;
}

function normalizePath(path?: string) {
  if (!path || path === "-") return "";
  return path.replace(/\/+$/, "") || "/";
}

export function LinksGroup({
  icon,
  label,
  initiallyOpened,
  link,
  links,
  onOpenmenu,
}: LinksGroupProps) {
  const location = useLocation();
  const current = normalizePath(location.pathname);
  const hasLinks = Array.isArray(links);
  const [opened, setOpened] = useState(initiallyOpened || false);

  const items = (hasLinks ? links : []).map((item) => {
    const itemPath = normalizePath(item.link);
    const isActive = current === itemPath;
    return (
      <Link
        key={item.label}
        to={item.link}
        onClick={onOpenmenu}
        className={`${classes.link}${isActive ? ` ${classes.linkActive}` : ""}`}
      >
        <span>{item.label}</span>
      </Link>
    );
  });

  const selfPath = normalizePath(link);
  const isSelfActive = !!selfPath && current === selfPath;

  return (
    <>
      {link === "-" ? (
        <>
          <UnstyledButton
            onClick={() => setOpened((o) => !o)}
            className={classes.control}
          >
            <Group justify="space-between" gap={0}>
              <Box style={{ display: "flex", alignItems: "center" }}>
                <ThemeIcon variant="light" color="blue" size={30} radius="md">
                  <AppUseIcon icon={icon} />
                </ThemeIcon>
                <Box ml="md">{label}</Box>
              </Box>
              {hasLinks && (
                <IconChevronRight
                  className={classes.chevron}
                  stroke={1.5}
                  size={16}
                  style={{ transform: opened ? "rotate(-90deg)" : "none" }}
                />
              )}
            </Group>
          </UnstyledButton>
          {hasLinks ? <Collapse expanded={opened}>{items}</Collapse> : null}
        </>
      ) : (
        <Link
          to={`${link}`}
          onClick={onOpenmenu}
          className={`${classes.control}${isSelfActive ? ` ${classes.active}` : ""}`}
        >
          <Group>
            <span className={classes.iconWrap}>
              <AppUseIcon icon={icon} />
            </span>
            <Box ml="md">{label}</Box>
          </Group>
        </Link>
      )}
    </>
  );
}

const mockdata = {
  label: "Releases",
  icon: "IconCalendarStats",
  link: "/",
  links: [
    { label: "Upcoming releases", link: "/" },
    { label: "Previous releases", link: "/" },
    { label: "Releases schedule", link: "/" },
  ],
};

export function NavbarLinksGroup() {
  return (
    <Box>
      <LinksGroup {...mockdata} />
    </Box>
  );
}
